import { computed, reactive } from 'vue';

// Module-level singleton so the print toggle (header) and the message list
// (a sibling in the component tree) can share selection state without prop
// drilling through ConversationBox.
const state = reactive({
  active: false,
  conversationId: null,
  selectedIds: new Set(),
});

export function usePrintSelection() {
  const isActive = computed(() => state.active);
  const selectedIds = computed(() => state.selectedIds);
  const selectedCount = computed(() => state.selectedIds.size);

  const start = conversationId => {
    state.active = true;
    state.conversationId = conversationId;
    state.selectedIds = new Set();
  };

  const cancel = () => {
    state.active = false;
    state.selectedIds = new Set();
  };

  const toggle = messageId => {
    const next = new Set(state.selectedIds);
    if (next.has(messageId)) {
      next.delete(messageId);
    } else {
      next.add(messageId);
    }
    state.selectedIds = next;
  };

  const isSelected = messageId => state.selectedIds.has(messageId);

  return {
    isActive,
    selectedIds,
    selectedCount,
    start,
    cancel,
    toggle,
    isSelected,
  };
}
